import { MemberBankHttpService } from '@core/services/member-bank-http.service';
import { ChangeDetectorRef, Component, HostListener, Input, OnInit, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthData } from '@core/models/auth-data';
import { BankAccount } from '@core/models/bank-account.model';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { loggedUser } from '@core/store/auth/auth.selectors';
import { select, Store } from '@ngrx/store';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { TranslateService } from '@ngx-translate/core';
import { BankWrapperModalComponent } from '@shared/bank-wrapper-modal/bank-wrapper-modal.component';
import { AppState } from '@store/reducers';
import { of, BehaviorSubject, Observable, Subscription, throwError } from 'rxjs';
import { catchError, delay, map, startWith, tap } from 'rxjs/operators';
import { BankAccountDataService } from '../../services/bank-account-data.service';
import { MatDialog } from '@angular/material/dialog';
import { EwalletVerificationModalComponent } from '@shared/ewallet-verification-modal/ewallet-verification-modal.component';
import svgIconList from 'assets/icons.json';
import { BankTypes } from '@core/enums/bank-type.enum';
@Component({
  selector: 'app-bank-modal',
  templateUrl: './bank-modal.component.html',
  styleUrls: ['./bank-modal.component.scss']
})
export class BankModalComponent implements OnInit {
  @ViewChildren('focusInput') focusInput: QueryList<ElementRef>;
  @ViewChild(MatAutocompleteTrigger, { read: MatAutocompleteTrigger }) inputAutoComplete: MatAutocompleteTrigger;
  svg: any = svgIconList;

  bankFieldVisible = false;
  form: FormGroup;
  bankAccounts$ = [];
  dataSub$ = new BehaviorSubject<any>(null);
  isSuccess = this.bankAccountDataService.isSuccess;
  dropDownbanks: any;
  userName = null;
  messages$ = this.bankAccountDataService.messages$;
  user$: Observable<AuthData>;
  checkValidity = false;
  windowInnerHeight: number;
  allBank = JSON.parse(sessionStorage.getItem('all_bank'));
  memberBankAccounts = JSON.parse(sessionStorage.getItem('member_bank_accounts'));
  countryCode = localStorage.getItem('country_code');
  userData = JSON.parse(localStorage.getItem('user_data'));
  selectedBankCode: string;
  private subscription = new Subscription();
  disabledButton = false;
  isVerificationSetting: boolean;
  isVerificationSettingForReupload: boolean;

  @Input()
  onDialog = false;

  @Input()
  existing_bank_name: any;

  @Input()
  is_deposit: boolean = false;

  @Input()
  is_transfer: boolean = false;

  @Input()
  is_withdraw: boolean = false;

  @Input()
  bank_type: any;

  bankDropdownList = [];
  selectedBank = [];
  paymentMethod = [];
  availablePaymentMethod = [];
  selectedPaymentMethod = [];
  selectedBankType = 'Bank';
  bankDropdownSettings = {
    enableSearchFilter: true,
    singleSelection: true,
    text: this.translateService.instant("Please Select"),
    primaryKey: 'id',
    labelKey: 'name',
    showCheckbox: false,
    tagToBody: false
  };
  paymentMethodDropdownSettings = {
    singleSelection: true,
    text: this.translateService.instant("Select Payment Method"),
    primaryKey: 'id',
    labelKey: 'name',
    showCheckbox: false,
    disabled: false
  };
  bankDropdownDialogSettings = {
    // enableSearchFilter: true, // Temporary disable this function, have issue with device virtual keyboard
    singleSelection: true,
    text: this.translateService.instant("Please Select"),
    primaryKey: 'id',
    labelKey: 'name',
    showCheckbox: false,
    maxHeight: '150'
  };

  myControl = new FormControl();
  filteredOptions: Observable<BankAccount[]>;
  availableOptions: any[] = [];
  payNowType = [
    { code: 'mobile', name: this.translateService.instant('Mobile Number') },
    { code: 'nric', name: this.translateService.instant('NRIC/FIN') },
    { code: 'uen', name: this.translateService.instant('Unique Entity Name (UEN)') },
    { code: 'vpa', name: this.translateService.instant('Virtual Payment Address (VPA)') },
  ];
  selectedType: any;

  // To check SG PayNow
  formValid = true;

  // To dispaly Payid text
  selectedBankPayidText: string;

  constructor(
    public dialogRef: MatDialogRef<BankWrapperModalComponent>,
    private bankAccountDataService: BankAccountDataService,
    private dropdownService: DropdownHttpService,
    private store: Store<AppState>,
    public loadingBar: LoadingBarService,
    private eventEmitterService: EventEmitterService,
    private cdr: ChangeDetectorRef,
    private translateService: TranslateService,
    private memberBankHttpService: MemberBankHttpService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.windowInnerHeight = window.innerHeight;
    this.formInit();
    this.reload();
    this.user$ = this.store.pipe(select(loggedUser));
    this.user$.subscribe();

    this.eventEmitterService.updateBankListEmitter.subscribe(() => {
      this.onGetBankAccount(null);
    });

    if (this.bank_type != undefined ) {
      if(this.dropDownbanks && this.dropDownbanks.length > 0) this.onSelectPaymentMethod(this.bank_type);

      if (this.bank_type == 1) {
        this.selectedPaymentMethod.push({ id: 1, name: this.translateService.instant('Bank') });
      }
      else if (this.bank_type == 3) {
        this.selectedPaymentMethod.push({ id: 3, name: this.translateService.instant('E-Wallet') });
      }else if(this.bank_type == 8){
        this.selectedPaymentMethod.push({ id: 8, name: this.translateService.instant('Pay ID') });
      }
      this.paymentMethodDropdownSettings.disabled = true;
    }

    // if (this.onDialog) {
    //   of(null).pipe(
    //     delay(200), tap(() => this.focusInput.first.nativeElement.focus()
    //     )).subscribe();
    // }

    if(this.userData.name){
      this.userName = this.userData.name;
    }
  }

  onGetBankAccount(memberBankAccounts: any, reload: boolean = false) {
    this.bankAccounts$ = [];
    
    if ( (!reload && memberBankAccounts !== null) || (reload && memberBankAccounts !== null) ) {
      this.bankAccounts$ = memberBankAccounts;
      this.dataSub$.next(memberBankAccounts);
      let existingBanks = [];
      memberBankAccounts.map(bank => {
        existingBanks.push(bank.bank_name);
      });
      this.existing_bank_name = existingBanks;
      this.filterBankList();
    } else {
      this.memberBankHttpService.getMemberBanks().pipe(
        tap(res => {
          sessionStorage.setItem('member_bank_accounts', JSON.stringify(res));
          this.memberBankAccounts = res;
          this.bankAccounts$ = res;
          this.dataSub$.next(res);
          let existingBanks = [];
          res.map(bank => {
            existingBanks.push(bank.bank_name);
          });
          this.existing_bank_name = existingBanks;
          this.filterBankList();
        })
      ).subscribe();
    }
  }

  onCloseDialog(event?: Event) {
    if (this.onDialog) {
      this.dialogRef.close();
      this.eventEmitterService.onReloadBankList();
    }
  }

  onSelectBank(value: any) {
    const bank_type = value.id;

    this.checkValidity = false;
    this.form.patchValue({
      account_number: null
    });
    this.selectedBankCode = bank_type === BankTypes.OTHERS ? 'OTHER' : value.code;

    if (bank_type === BankTypes.OTHERS) {
      this.bankFieldVisible = true;
      this.form.get('bank_name').setValidators([Validators.required, Validators.pattern(/^[a-zA-Z0-9\s]+$/)]);
      this.form.get('bank_name').updateValueAndValidity();
      this.form.patchValue({
        bank_id: BankTypes.OTHERS,
      });
    } else {
      this.bankFieldVisible = false;
      this.form.get('bank_name').clearValidators();
      this.form.get('bank_name').updateValueAndValidity();
      this.form.patchValue({
        bank_id: bank_type,
      });
    }

    if (this.selectedType !== undefined) {
      this.resetPayNowField();
    }
    if (!(value.code === 'PAYNOW' && this.countryCode === 'SG')) {
      this.form.get('account_number').setValidators([Validators.required, Validators.pattern(/^[a-zA-Z0-9\s]+$/)]);
      this.form.get('account_number').updateValueAndValidity();
    }

    if(value.code === 'PAYIDABN' || value.code === 'PAYIDEMAIL' || value.code === 'PAYIDMOB'){
      if(value.code === 'PAYIDEMAIL'){
        this.form.get('account_number').setValidators([Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]);
        this.form.get('account_number').updateValueAndValidity();
        this.selectedBankPayidText = 'Email Address';
      }else if(value.code === 'PAYIDMOB'){
        this.form.get('account_number').setValidators([Validators.required, Validators.pattern(/^(\+61|61|0)4\d{8}$/)]);
        this.form.get('account_number').updateValueAndValidity();
        this.selectedBankPayidText = 'Phone Number';
      }else{
        this.form.get('account_number').setValidators([Validators.required, Validators.pattern(/^(?:\d{11}|\d{9})$/)]);
        this.form.get('account_number').updateValueAndValidity();
        this.selectedBankPayidText = 'Business Number (ABN / ACN)';
      }
    }else{
      this.selectedBankPayidText = null;
    }

  }

  onSelectType(item: any) {
    this.resetPayNowField();
    this.selectedType = item;
    this.setPayNowValidity();
  }

  OnDeSelectBank() {
    this.checkValidity = false;
    this.selectedBankCode = undefined;
    this.selectedBank = [];
    this.form.patchValue({
      bank_id: null,
      account_number: null
    });
    this.bankFieldVisible = false;
  }

  OnDeSelectPaymentMethod() {
    this.bankDropdownList = [];
    this.selectedBankCode = undefined;
    this.selectedBank = [];
    this.form.patchValue({
      bank_type: null,
      bank_id: null,
      account_number: null
    });
    this.bankFieldVisible = false;
    this.setSelectedBankTypeBank();
    this.selectedBankPayidText = null;
  }

  onSave() {
    this.checkValidity = true;
    if (this.form.valid && this.formValid) {
      this.loadingBar.start();
      this.disabledButton = true;
      const data = {
        ...this.form.value,
        is_deposit: this.is_deposit
      };
      Object.keys(data).forEach((key) => (data[key] == null || data[key] === '' || (!this.bankFieldVisible && key === 'bank_name')) && delete data[key]);
      this.bankAccountDataService.addBank(data).pipe(
        catchError(err => {
          this.loadingBar.complete();
          this.checkValidity = false;
          this.disabledButton = false;
          return throwError(err);
        })
      ).subscribe(() => {
        this.loadingBar.complete();
        this.isSuccess = this.bankAccountDataService.isSuccess;
        this.checkValidity = false;
        this.disabledButton = false;
        this.bankFieldVisible = false;
        if (this.isSuccess) {
          this.onGetBankAccount(null, true);
          if (this.userName === null) {
            this.userName = data.account_name;
            this.form.patchValue({ account_name: data.account_name });
            // Update local storage user_data name
            const userData = JSON.parse(localStorage.getItem('user_data'));
            Object.keys(userData).forEach(function (key) {
                if(key == 'name'){ 
                  userData[key] = data.account_name;
                }
            });
            localStorage.setItem('user_data', JSON.stringify(userData));
          }
          this.bankDropdownList = this.dropDownbanks.filter(x => x.id != this.form.get('bank_id').value && x.bank_type == this.form.get('bank_type').value);
          if (this.bankDropdownList.length == 0 && this.form.get('bank_type').value != 1) {
            this.availablePaymentMethod = this.availablePaymentMethod.filter(x => x.id != this.form.get('bank_type').value);
          }
          this.bankDropdownList = [];
          this.selectedPaymentMethod = [];
          this.setSelectedBankTypeBank();
          if (this.onDialog) {
            this.dialogRef.close();
          } else {
            this.onGetBankAccount(null, true);
            this.formInit();
            this.resetPayNowField();
          }
          this.selectedBank = [];
          this.eventEmitterService.onReloadBankList();
          this.eventEmitterService.onUpdateProfileName();
          this.selectedBankCode = undefined;
        }
      });
    }
  }

  onDeactivate(bank_id: number) {
    this.loadingBar.start();
    this.bankAccountDataService.deleteBank(bank_id).subscribe(() => {
      this.loadingBar.complete();
      this.isSuccess = this.bankAccountDataService.isSuccess;
    })
  }

  displayFn(bank: BankAccount): string {
    return bank && bank.name ? bank.name : '';
  }

  openPanel(event) {
    event.stopPropagation();
    this.inputAutoComplete.openPanel();
  }

  private filterBankList() {
    if (this.allBank !== null) {
      this.setPaymentMethodDropdown(this.allBank.filter((item) => {
        return !this.existing_bank_name.includes(item.name);
      }));
      this.dropDownbanks = this.allBank.filter((item) => {
        return !this.existing_bank_name.includes(item.name);
      });
      this.setBankDropdown();
      this.cdr.detectChanges();
    } else {
      this.dropdownService.banks.pipe(
        map((res) => {
          this.allBank = res;
          sessionStorage.setItem('all_bank', JSON.stringify(res));
          this.setPaymentMethodDropdown(res);
          return res.filter((item) => {
            return !this.existing_bank_name.includes(item.name);
          })
        })
      ).subscribe((res) => {
        this.dropDownbanks = res;
        this.setBankDropdown();
        if(this.bank_type != undefined) {
          this.onSelectPaymentMethod(this.bank_type);

          if (this.bank_type == 1) {
            this.selectedPaymentMethod.push({id: 1, name: this.translateService.instant('Bank') });
          }
          else if (this.bank_type == 3) {
            this.selectedPaymentMethod.push({ id: 3, name: this.translateService.instant('E-Wallet') });
          }else if(this.bank_type == 8){  
            this.selectedPaymentMethod.push({ id: 8, name: this.translateService.instant('Pay ID') });
          }

          this.paymentMethodDropdownSettings = {
            singleSelection: true,
            text: this.translateService.instant("Select Payment Method"),
            primaryKey: 'id',
            labelKey: 'name',
            showCheckbox: false,
            disabled: true
          };
        }
        this.cdr.detectChanges();
      });
    }
  }

  private setBankDropdown() {
    this.dropDownbanks.push({ id: BankTypes.OTHERS, name: "Others", bank_type: 1, bank_type_name: "Bank" });

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => (typeof value === 'string' ? value : value.name)),
      map(name => (name ? this._filter(name) : this.dropDownbanks.slice())),
    );
  }

  private setPaymentMethodDropdown(data: any) {
    if (this.paymentMethod.length == 0) {
      data = data.filter(item => item.bank_type !== 6);
      
      data?.push({ id: BankTypes.OTHERS, name: "Others", bank_type: 1, bank_type_name: "Bank" });
      
      // Get single data with different payment method
      let filteredPaymentMethod = data.filter(
        (item, i, arr) => arr.findIndex(x => x.bank_type === item.bank_type) === i
      );
      // Get different payment method
      for (let i = 0; i < filteredPaymentMethod.length; i++) {
        this.paymentMethod.push({ id: filteredPaymentMethod[i].bank_type, name: this.translateService.instant(filteredPaymentMethod[i].bank_type_name) });
      }
      this.availablePaymentMethod = this.paymentMethod.sort(function (a, b) {
        if (a.id < b.id) {
          return -1;
        }
        if (a.id > b.id) {
          return 1;
        }
        return 0;
      });
    }
  }

  private _filter(name: string): any {
    const filterValue = name.toLowerCase();
    this.availableOptions = this.dropDownbanks.filter(option => option.name.toLowerCase().includes(filterValue));
    if (this.availableOptions.length === 0) {
      return this.availableOptions = [{ name: 'No Data Available', id: null }];
    } else {
      return this.availableOptions;
    }
  }

  private reload() {
    this.onGetBankAccount(this.memberBankAccounts, true);
  }

  private formInit() {
    this.form = new FormGroup({
      bank_id: new FormControl(null, [Validators.required]),
      bank_type: new FormControl(null, [Validators.required]),
      account_number: new FormControl(null, [Validators.required]),
      bank_name: new FormControl(null, [Validators.pattern(/^[a-zA-Z0-9\s]+$/)]),
      bsb_code: new FormControl(null, [Validators.pattern(/^\d{6}$/)]),
      account_name: new FormControl(null),
      mobile_number: new FormControl(null),
      nric_fin: new FormControl(null),
      unique_entity_name: new FormControl(null),
      virtual_payment_address: new FormControl(null)
    });
  }

  private setPayNowValidity() {
    if (this.selectedBankCode === 'PAYNOW' && this.countryCode === 'SG') {
      this.form.get('account_number').clearValidators();
      if (this.selectedType === 'mobile') {
        this.form.controls.mobile_number.setValidators(Validators.required);
        this.form.controls.nric_fin.clearValidators();
        this.form.controls.unique_entity_name.clearValidators();
        this.form.controls.virtual_payment_address.clearValidators();
        this.form.patchValue({
          account_number: null,
          mobile_number: this.userData.phone,
        });
      } else if (this.selectedType === 'nric') {
        this.form.controls.nric_fin.setValidators(Validators.required);
        this.form.controls.mobile_number.clearValidators();
        this.form.controls.unique_entity_name.clearValidators();
        this.form.controls.virtual_payment_address.clearValidators();
      } else if (this.selectedType === 'uen') {
        this.form.controls.unique_entity_name.setValidators(Validators.required);
        this.form.controls.mobile_number.clearValidators();
        this.form.controls.nric_fin.clearValidators();
        this.form.controls.virtual_payment_address.clearValidators();
      } else if (this.selectedType === 'vpa') {
        this.form.controls.virtual_payment_address.setValidators(Validators.required);
        this.form.controls.mobile_number.clearValidators();
        this.form.controls.nric_fin.clearValidators();
        this.form.controls.unique_entity_name.clearValidators();
      }
    } else {
      this.resetPayNowField();
    }
    this.updateFormValidity();
  }

  private resetPayNowField() {
    this.selectedType = undefined;
    this.form.patchValue({
      mobile_number: null,
      nric_fin: null,
      unique_entity_name: null,
      virtual_payment_address: null,
    });
    this.form.controls.mobile_number.clearValidators();
    this.form.controls.nric_fin.clearValidators();
    this.form.controls.unique_entity_name.clearValidators();
    this.form.controls.virtual_payment_address.clearValidators();
    this.updateFormValidity();
  }

  private updateFormValidity() {
    Object.keys(this.form.controls).forEach((key) => {
      this.form.get(key).updateValueAndValidity();
    });
  }

  @HostListener('window:resize', [])
  onResize() {
    if (window.innerHeight < this.windowInnerHeight) {
      window.scroll(0, 100);
    }
  }

  onSelectPaymentMethod(bank_type: any) {
    this.bankDropdownList = this.dropDownbanks.filter(x => x.bank_type == bank_type);

    if(bank_type == BankTypes.BANK) {
      this.setSelectedBankTypeBank();
    }
    else if(bank_type == BankTypes.EWALLET) {
      this.setSelectedBankTypeEwallet();
    }else if (bank_type == BankTypes.PAYID) {
      this.setSelectedBankTypePayid();
      this.bankDropdownList = this.bankDropdownList.sort((a, b) => {
                                const order = { 'PAYIDMOB': 1, 'PAYIDEMAIL': 2, 'PAYIDABN': 3 };
                                return order[a.code] - order[b.code];
                              });
    }

    this.form.reset();
    this.selectedBankCode = null;
    this.selectedBank = [];
    this.form.patchValue({
      bank_type: bank_type,
    });
    this.updateBsbValidation();
  }

  setSelectedBankTypeBank() {
    this.selectedBankType = 'Bank';
    this.bankDropdownSettings = {
      enableSearchFilter: true,
      singleSelection: true,
      text: this.translateService.instant("Select Bank"),
      primaryKey: 'id',
      labelKey: 'name',
      showCheckbox: false,
      tagToBody: false
    };
  }

  setSelectedBankTypeEwallet() {
    this.selectedBankType = 'E-Wallet';
    this.bankDropdownSettings = {
      enableSearchFilter: true,
      singleSelection: true,
      text: this.translateService.instant("Select E-Wallet"),
      primaryKey: 'id',
      labelKey: 'name',
      showCheckbox: false,
      tagToBody: false
    };
  }

  setSelectedBankTypePayid() {
    this.selectedBankType = 'PayID';
    this.bankDropdownSettings = {
      enableSearchFilter: true,
      singleSelection: true,
      text: this.translateService.instant("Select PayID"),
      primaryKey: 'id',
      labelKey: 'name',
      showCheckbox: false,
      tagToBody: false
    };
  }

  onOpenDialog(reupload?: boolean, bankAccount?: any, verificationSetting?: any) {
    if (reupload == true) {
      this.openDialogBy(EwalletVerificationModalComponent, reupload, bankAccount);
    } else {
      this.openDialogBy(EwalletVerificationModalComponent, reupload, null, this.form.value, verificationSetting);
    }
  }

  private openDialogBy(componentRef: any, reupload?: boolean, bankAccount?: any, formValue?: any, verificationSetting?: any) {
    if (reupload == true) {
      var dialogRef = this.dialog.open(componentRef, {
        width: 'auto',
        data: {
          reupload: reupload,
          bankAccountId: bankAccount.id,
          reason: bankAccount.reason,
          verificationSetting: bankAccount,
          bankVerificationStatus: bankAccount.status
        } 
      });
    } else {
      var dialogRef = this.dialog.open(componentRef, {
        width: 'auto',
        data: {
          reupload: reupload,
          account_name: formValue.account_name,
          account_number: formValue.account_number,
          bsb_code: formValue.bsb_code,
          bank_id: formValue.bank_id,
          bank_type: formValue.bank_type,
          verificationSetting: verificationSetting
        } 
      });
    }

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.formInit();
        this.eventEmitterService.onReloadBankList();
        this.selectedBank = [];
        this.bankDropdownList = [];
        this.selectedPaymentMethod = [];
        this.setSelectedBankTypeBank();
        this.checkValidity = false;
        this.resetPayNowField();
        if (this.onDialog) {
          this.dialogRef.close();
        }
      }
    });
  }

  onSubmit(selectedBank?: any, reupload?: boolean, bankAccount?: any) {
    // Normal add bank
    if (selectedBank) {
      this.isVerificationSetting = selectedBank[0]['verification_setting_id'] != null && selectedBank[0]['verification_settings_field'].length > 0 ? true : false;
    }

    // Reupload
    if (bankAccount) {
      this.isVerificationSettingForReupload = bankAccount.status != null ? true : false;
    }

    if (this.isVerificationSetting || this.isVerificationSettingForReupload) {
      if (reupload == true) {
        this.onOpenDialog(reupload, bankAccount);
      } else if (this.is_deposit) {
        // Direct save bank account without submit verification details in deposit page and not reupload action
        this.onSave(); 
      }  else {
        this.form.markAllAsTouched();
        this.checkValidity = true;
        if (this.form.valid) {
          this.onOpenDialog(reupload, null, selectedBank);
        }
      }
    } else {
      this.onSave(); 
    }
  }

  updateBsbValidation() {
    const bsbControl = this.form.get('bsb_code');
    if (this.selectedBankType == 'Bank' && this.countryCode == 'AU') {
      bsbControl?.setValidators([Validators.required, Validators.pattern(/^\d{6}$/)]);
    } else {
      bsbControl?.setValidators([Validators.pattern(/^\d{6}$/)]);
    }

    bsbControl?.updateValueAndValidity();
  }
}
